import {
	API
} from "aws-amplify"

export interface RequestAccountPayload {
	name: string
	company: string
	email: string
	phone?: string
	honeypot: string
	token: string
}

export interface RequestAccountResult {
	result: "OK" | "error"
	code?: string
	message?: string
}

// submits a new account request to the (unauthenticated) request-account endpoint
export default async function requestAccount(payload: RequestAccountPayload): Promise<RequestAccountResult> {
	return await API.post("fmDataAPI", "/request-account", {
		body: {
			action: "userRequest",
			payload: payload
		}
	})
}
